export default __webpack_public_path__ + "static/media/open-positions-4k.e90ef28c.jpg";